import React from 'react';
import ReactPaginate from 'react-paginate';
import '../../src/assets/styles/components/paginate.css';
import {Trans} from 'react-i18next';

export default function Paginate({
  grid,
  clickCallback,
  selectCallback,
  classname,
  selectShow = true,
}) {
  if (!grid || !grid.totalSize || grid.totalSize === 1) {
    return <div />;
  }
  const count1 = (grid.pageIndex - 1) * grid.pageSize + 1;
  const count2 =
    grid.pageIndex === grid.pages && grid.totalSize
      ? grid.pageIndex === grid.pages && grid.totalSize
      : '';
  const count3 =
    grid.pageIndex !== grid.pages ? grid.pageIndex * grid.pageSize : ' ';
  const count4 = grid.totalSize;

  return (
    <div className={`paginate-${classname}`} style={{display: 'flex'}}>
      <div className="paginate-records">
        <Trans i18nKey="c.paginate.pageindex">
          Showing {{count1}} to {{count2}}
          {{count3}} of {{count4}} records
        </Trans>
      </div>
      <div className="paginate-page" style={{marginLeft: 'auto'}}>
        <div
          id="react-paginate"
          style={{
            justifyContent: 'space-between',
            display: 'flex',
            // float: 'right',
          }}
        >
          {selectShow && (
            <div className="dataTables_length" style={{display: 'flex'}}>
              <label style={{padding: '5px 5px 0 0', whiteSpace: 'nowrap'}}>
                <Trans i18nKey="c.paginate.display">Display</Trans>
              </label>
              <select
                value={grid.pageSize}
                name="pageSize"
                className="custom-select custom-select-sm"
                onChange={e => {
                  clickCallback({selected: 0});
                  selectCallback(e.target.value);
                }}
                style={{minWidth: '50px'}}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <label style={{padding: '5px 0 0 5px', wordBreak: 'keep-all'}}>
                <Trans i18nKey="c.paginate.records">records</Trans>
              </label>
            </div>
          )}
          <div className="dataTables_paginate paging_bootstrap_full_number">
            <ReactPaginate
              forcePage={grid.pageIndex - 1}
              previousLabel={<i className="fa fa-angle-left" />}
              nextLabel={<i className="fa fa-angle-right" />}
              breakLabel={<i className="fa fa-ellipsis-h" />}
              pageCount={grid.pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={clickCallback}
              activeClassName={'active'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
